import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue";
export default /*#__PURE__*/_defineComponent({
  props: {
    loading: Boolean
  },
  setup: function setup(__props) {
    var svg = "<svg width=\"57\" height=\"57\" viewBox=\"0 0 57 57\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<circle cx=\"28.2852\" cy=\"10.6066\" r=\"7.5\" transform=\"rotate(45 28.2852 10.6066)\" fill=\"#528BFF\"/>\n<circle cx=\"45.9609\" cy=\"28.2843\" r=\"7.5\" transform=\"rotate(45 45.9609 28.2843)\" fill=\"#7AA6FF\"/>\n<circle cx=\"28.2852\" cy=\"45.9618\" r=\"7.5\" transform=\"rotate(45 28.2852 45.9618)\" fill=\"#ADC8FF\"/>\n<circle cx=\"10.6094\" cy=\"28.2843\" r=\"7.5\" transform=\"rotate(45 10.6094 28.2843)\" fill=\"#D6E4FF\"/>\n</svg>\n";
    return function (_ctx, _cache) {
      var _directive_loading = _resolveDirective("loading");

      return _withDirectives((_openBlock(), _createElementBlock("div", {
        "element-loading-svg": svg,
        "element-loading-svg-view-box": "0, 0, 57, 57",
        style: {
          "min-height": "120px"
        },
        "element-loading-background": "rgba(255, 255, 255, 0.6)"
      }, [_renderSlot(_ctx.$slots, "default")])), [[_directive_loading, __props.loading]]);
    };
  }
});